import { render } from "./CatalogProductsOverviewCriteria.vue?vue&type=template&id=078ec31e&scoped=true&ts=true"
import script from "./CatalogProductsOverviewCriteria.vue?vue&type=script&lang=ts"
export * from "./CatalogProductsOverviewCriteria.vue?vue&type=script&lang=ts"

import "./CatalogProductsOverviewCriteria.vue?vue&type=style&index=0&id=078ec31e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078ec31e"]])

export default __exports__